import { RulesData } from '.';
import { IAction } from '../root/i-action';
import { IState } from '../root/state.interface';

export const getRulesAndStatementsRequest = (state: IState): IState => ({
  ...state,
  rulesData: {
    loading: true,
    loaded: false,
    data: {
      rules: [],
      statements: [],
    },
  },
});

export const getRulesAndStatementsSuccess = (
  state: IState, action: IAction<RulesData>,
): IState => ({
  ...state,
  rulesData: {
    loading: false,
    loaded: true,
    data: action.payload,
  },
});

export const getRulesAndStatementsFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  rulesData: {
    loading: false,
    loaded: false,
    error: action.payload,
    data: {
      rules: [],
      statements: [],
    },
  },
});

export const getTransformsAndStatementsRequest = (state: IState): IState => ({
  ...state,
  transformsData: {
    loading: true,
    loaded: false,
    data: {
      rules: [],
      statements: [],
    },
  },
});

export const getTransformsAndStatementsSuccess = (
  state: IState, action: IAction<RulesData>,
): IState => ({
  ...state,
  transformsData: {
    loading: false,
    loaded: true,
    data: action.payload,
  },
});

export const getTransformsAndStatementsFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  transformsData: {
    loading: false,
    loaded: false,
    error: action.payload,
    data: {
      rules: [],
      statements: [],
    },
  },
});

export const getSystemConfigAndStatementsRequest = (state: IState): IState => ({
  ...state,
  systemConfigData: {
    loading: true,
    loaded: false,
    data: {
      rules: [],
      statements: [],
    },
  },
});

export const getSystemConfigAndStatementsSuccess = (
  state: IState, action: IAction<RulesData>,
): IState => ({
  ...state,
  systemConfigData: {
    loading: false,
    loaded: true,
    data: action.payload,
  },
});

export const getSystemConfigAndStatementsFail = (
  state: IState, action: IAction<Error>,
): IState => ({
  ...state,
  systemConfigData: {
    loading: false,
    loaded: false,
    error: action.payload,
    data: {
      rules: [],
      statements: [],
    },
  },
});

export const getScheduleRulesRequest = (state: IState): IState => ({
  ...state,
  scheduledRulesData: {
    loading: true,
    loaded: false,
    data: {
      rules: [],
      statements: [],
    },
  },
});

export const getScheduleRulesSuccess = (
  state: IState, action: IAction<RulesData>,
): IState => ({
  ...state,
  scheduledRulesData: {
    loading: false,
    loaded: true,
    data: action.payload,
  },
});

export const getScheduleRulesFail = (
  state: IState, action: IAction<Error>,
): IState => ({
  ...state,
  scheduledRulesData: {
    loading: false,
    loaded: false,
    error: action.payload,
    data: {
      rules: [],
      statements: [],
    },
  },
});

export const updateRulesRequest = (state: IState): IState => ({
  ...state,
  rulesData: {
    ...state.rulesData,
    loading: true,
  },
});

export const updateRulesSuccess = (state: IState): IState => ({
  ...state,
  rulesData: {
    ...state.rulesData,
    loading: false,
  },
});

export const updateRulesFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  rulesData: {
    ...state.rulesData,
    loading: false,
    error: action.payload,
  },
});

export const updateTransformsRequest = (state: IState): IState => ({
  ...state,
  transformsData: {
    ...state.transformsData,
    loading: true,
  },
});

export const updateTransformsSuccess = (state: IState): IState => ({
  ...state,
  transformsData: {
    ...state.transformsData,
    loading: false,
  },
});

export const updateTransformsFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  transformsData: {
    ...state.transformsData,
    loading: false,
    error: action.payload,
  },
});

export const updateSystemConfigRequest = (state: IState): IState => ({
  ...state,
  systemConfigData: {
    ...state.systemConfigData,
    loading: true,
  },
});

export const updateSystemConfigSuccess = (state: IState): IState => ({
  ...state,
  systemConfigData: {
    ...state.systemConfigData,
    loading: false,
  },
});

export const updateSystemConfigFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  systemConfigData: {
    ...state.scheduledRulesData,
    loading: false,
    error: action.payload,
  },
});

export const updateScheduledRulesRequest = (state: IState): IState => ({
  ...state,
  scheduledRulesData: {
    ...state.scheduledRulesData,
    loading: true,
  },
});

export const updateScheduledRulesSuccess = (state: IState): IState => ({
  ...state,
  scheduledRulesData: {
    ...state.scheduledRulesData,
    loading: false,
  },
});

export const updateScheduledRulesFail = (state: IState, action: IAction<Error>): IState => ({
  ...state,
  scheduledRulesData: {
    ...state.scheduledRulesData,
    loading: false,
    error: action.payload,
  },
});
